import { render, staticRenderFns } from "./luckDraw.vue?vue&type=template&id=fbcaa9a8&scoped=true&"
import script from "./luckDraw.ts?vue&type=script&lang=ts&"
export * from "./luckDraw.ts?vue&type=script&lang=ts&"
import style0 from "./luckDraw.vue?vue&type=style&index=0&id=fbcaa9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcaa9a8",
  null
  
)

export default component.exports